import { useEffect, useState, type CSSProperties } from "react";

export function hashAvatarCadastro(texto: string): number {
  let hash = 0;
  for (let i = 0; i < texto.length; i++) {
    hash = (hash << 5) - hash + texto.charCodeAt(i);
    hash |= 0;
  }
  return hash;
}

export function iniciaisAvatarCadastro(nome: string): string {
  return (
    String(nome || "")
      .trim()
      .split(/\s+/)
      .map((parte) => parte[0])
      .filter(Boolean)
      .slice(0, 2)
      .join("")
      .toUpperCase() || "?"
  );
}

export function estiloAvatarCadastro(nome: string): CSSProperties {
  const primario = String(nome || "Sem nome");
  const hue = Math.abs(hashAvatarCadastro(primario || iniciaisAvatarCadastro(primario))) % 360;
  return { "--h": hue } as CSSProperties;
}

interface AvatarCadastroProps {
  nome: string;
  /** URL da foto/logo. Sem ela, cai no círculo colorido com as iniciais. */
  foto?: string;
  /** Tamanho do círculo em px (padrão do CSS: 32, usado nas listagens). */
  tamanho?: number;
  /** Produto: quadrado de canto arredondado em vez de círculo. */
  quadrado?: boolean;
  className?: string;
  corFundo?: string;
}

/**
 * Avatar padrão dos cadastros: círculo com cor derivada do nome + iniciais.
 * Quando há foto/logo, a imagem preenche o círculo. Mesmo markup/classes do
 * `CelulaNome`, para manter um único visual de avatar na plataforma. Imagem de
 * produto usa `quadrado`, que é a forma dela em toda a plataforma.
 */
export function AvatarCadastro({ nome, foto, tamanho, quadrado = false, className, corFundo }: AvatarCadastroProps) {
  const primario = nome || "Sem nome";
  const [fotoValida, setFotoValida] = useState(Boolean(foto));

  useEffect(() => {
    setFotoValida(Boolean(foto));
  }, [foto]);

  const estilo: CSSProperties = {
    ...estiloAvatarCadastro(primario),
    ...(corFundo ? { background: corFundo, color: "#fff" } : null),
    ...(tamanho ? { width: tamanho, height: tamanho, fontSize: Math.max(9, Math.round(tamanho * 0.34)) } : null),
  };

  return (
    <div
      className={`cad-avatar${fotoValida ? " cad-avatar--photo" : ""}${quadrado ? " cad-avatar--quadrado" : ""}${className ? ` ${className}` : ""}`}
      style={estilo}
      aria-hidden="true"
    >
      {fotoValida && foto && <img src={foto} alt="" onError={() => setFotoValida(false)} />}
      <span className="cad-avatar__initials">{iniciaisAvatarCadastro(primario)}</span>
    </div>
  );
}
